import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { StatusPill } from "@/components/StatusPill";
import { useI18n } from "@/i18n/I18nContext";
import { Image, Loader2, Lock } from "lucide-react";

export default function Assets() {
  const [items, setItems] = useState(null);
  const { t } = useI18n();
  useEffect(() => { api.assets().then(setItems); }, []);
  if (!items) return <div className="flex items-center justify-center py-32"><Loader2 className="animate-spin text-[#2563EB]" /></div>;
  return (
    <div className="space-y-6">
      <div>
        <p className="mono-label">DIGITAL ASSET LIBRARY · ELIN (AG075)</p>
        <h1 className="font-display text-3xl font-extrabold text-white mt-1 flex items-center gap-2"><Image className="text-[#2563EB]" /> {t("as.title")}</h1>
        <p className="text-sm text-[#94A3B8] mt-1">{t("as.subtitle")}</p>
      </div>
      {items.length === 0 ? <div className="m-card p-10 text-center text-[#64748B] text-sm">{t("as.empty")}</div> : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((a) => (
            <div key={a.id} className="m-card p-5" data-testid={`asset-${a.id}`}>
              <div className="flex items-center justify-between">
                <span className="mono-label">{a.asset_type}</span>
                {a.lock_state === "FROZEN" ? <span className="m-pill text-[#A5B4FC]" style={{ borderColor: "#4338CA", background: "#1E1B4B" }}><Lock size={11} /> FROZEN</span> : <StatusPill status={a.approval_state} />}
              </div>
              <p className="text-white font-semibold mt-3">{a.name}</p>
              <p className="text-[11px] text-[#64748B] font-mono mt-1">{a.project_code} · v{a.current_version} · {t("as.versions", { n: a.versions?.length || 0 })}</p>
              {a.versions?.[0]?.body && <p className="text-xs text-[#94A3B8] mt-2 line-clamp-3">{a.versions[0].body}</p>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
